import { ReactNode } from 'react';

import { ToolGroupProps } from '@/components/assistant-ui/use-tool-group-state';

export function DefaultToolGroup({ children }: ToolGroupProps): ReactNode {
  return <>{children}</>;
}
